// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__1Uq4B","list_item":"styles_list_item__35yOk","more":"styles_more__2Inaq"};